import { DifferenzaDTO } from "@dto/differenzaDTO";
import { FascicoloDTO } from "@dto/fascicoloDTO";
import { TipoOperazioneFascicoloEnum } from "@enum/tipo-operazione-fascicolo-enum";
import { TipoOperazioneUnitaDocumentariaEnum } from "../enum/tipo-operazione-unita-documentaria-enum";
import { IperFascicoloDTO } from "./iper-fascicoloDTO";
import { UnitaDocumentariaDTO } from "./unita-documentariaDTO";
import { UtenteDTO } from "./utenteDTO";

export class AttivitaUnitaDocumentariaDTO {
  idFascicolo: string;
  differenze: DifferenzaDTO[];
  idUnitaDocumentaria: string;
  dataOperazione: string;
  operatore: UtenteDTO;
  tipoOperazione: TipoOperazioneUnitaDocumentariaEnum;
}
